import { render } from "./Quotation1.vue?vue&type=template&id=2c65560e"
import script from "./Quotation1.vue?vue&type=script&lang=js"
export * from "./Quotation1.vue?vue&type=script&lang=js"
script.render = render

export default script